import styled from 'styled-components';

export const Layout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 0px 20px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const NotFound = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    gap: 24px;
`;
